// for plans FREE and PRO

module.exports = exports = [
  {
    items: [
      {
        name: "Multiple users access to the same workspace",
        available: [false, false, true, true]
      },
      {
        name: "Role-based permissions",
        available: [false, false, true, true]
      },
      {
        name: "Included Team Workspaces",
        available: ["-", "-", 1, "1 or more"]
      },
      {
        name: "On-premises",
        available: [false, false, false, true],
        tooltip: "You decide where and how to host your databases"
      },
      {
        name: "Offline license",
        available: [false, false, false, true],
        tooltip: "An offline license allows you to be 100% offline if needed"
      },
      {
        name: "Priority support",
        available: [false, false, false, true],
        tooltip:
          "To make sure everything runs smoothly on your own infrastructure. Higher priority on feature requests as well."
      },
      {
        name:
          "Users have access to all features on both Local and Team Workspaces",
        available: [false, false, false, true],
        tooltip:
          "On the TEAM plan, users without a subscription of their own have access to all features only on the Team Workspaces they belong to whereas on the ENTERPRISE plan all users have access to all the features on both Local and Team Workspaces."
      }
    ]
  },
  {
    title: "Inventory",
    items: [
      {
        name: "Parts",
        available: ["1 000", "unlimited", "unlimited", "unlimited"]
      },
      {
        name: "Max. stock per part",
        available: ["5 500", "unlimited", "unlimited", "unlimited"]
      },
      {
        name: "Max. low stock value per part",
        available: [100, "unlimited", "unlimited", "unlimited"]
      },
      { name: "Datasheets", available: [true, true, true, true] },
      {
        name: "Part alternates",
        available: [true, true, true, true],
        tooltip: "Quickly replace parts in BOMs"
      },
      {
        name: "Global history",
        available: [true, true, true, true]
      },
      {
        name: "Generic parts",
        available: ["partial", true, true, true],
        tooltip:
          '"Virtual" parts that represent a group of real parts for a given specification (e.g. CAP_10u_0805_16V). Generic parts allow you to postpone the decision of picking a real part to use during production or when procuring them.'
      },
      { name: "Internal part numbers", available: [false, true, true, true] },
      { name: "Inventory value report", available: [false, true, true, true] },
      {
        name: "Custom fields",
        available: [false, true, true, true]
      },
      {
        name: "Attrition rate calculations",
        available: [false, true, true, true],
        tooltip: "Attrition rate accounts for losses during production."
      },
      {
        name: "Lot control",
        available: [false, true, true, true]
      }
    ]
  },
  {
    title: "BOM Management",
    items: [
      {
        name: "Products",
        available: ["unlimited", "unlimited", "unlimited", "unlimited"]
      },
      {
        name: "BOM revisions",
        available: ["unlimited", "unlimited", "unlimited", "unlimited"]
      },
      {
        name: "Production builds",
        available: ["unlimited", "unlimited", "unlimited", "unlimited"],
        tooltip:
          "Track your production so you know if inventory has been reserved or already used during assembly."
      },
      {
        name: "Multi-step production builds",
        available: [true, true, true, true],
        tooltip: "Reserve stock and assemble items in several steps."
      },
      {
        name: "Pricing & Availability",
        available: ["partial", true, true, true],
        tooltip:
          "Check for stock availability on suppliers, get real-time quotes and estimate production costs. On the MAKER plan, availability info is provided but without pricing."
      },
      {
        name: "Sub-assemblies",
        available: [false, true, true, true]
      },
      {
        name: "Advanced production planning",
        available: [false, true, true, true],
        tooltip:
          "Plan and schedule production for different products at the same time"
      }
    ]
  },
  {
    title: "Purchasing",
    items: [
      {
        name: "Purchase lists",
        available: ["unlimited", "unlimited", "unlimited", "unlimited"]
      },
      {
        name: "Purchase orders",
        available: ["unlimited", "unlimited", "unlimited", "unlimited"]
      },
      {
        name: "Pricing & Availability",
        available: ["partial", true, true, true]
      }
    ]
  },
  {
    title: "Suppliers",
    items: [
      {
        name: "Custom suppliers and quotes",
        available: [true, true, true, true]
      }
    ]
  },
  {
    title: "Sales Management",
    items: [
      {
        name: "Sales orders",
        available: [false, true, true, true]
      },
      {
        name: "Customers",
        available: [false, true, true, true]
      }
    ]
  },
  {
    title: "Other Features",
    items: [
      {
        name: "Barcode labels (printing and scanning)",
        available: [true, true, true, true]
      },
      {
        name: "REST API",
        available: [true, true, true, true]
      },
      {
        name: "Export tables into CSV, JSON, HTML and PDF format",
        available: [true, true, true, true]
      },
      {
        name: "Units of measure",
        available: [true, true, true, true]
      },
      {
        name: "Multiple storage locations",
        available: [true, true, true, true]
      },
      {
        name: "Attach unlimited documents to everything",
        available: [true, true, true, true]
      },
      {
        name: "Write and save notes in Markdown text",
        available: [true, true, true, true]
      },
      {
        name: "Multiple currencies",
        available: [true, true, true, true]
      }
    ]
  }
];
